/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import * as THREE from 'three';
import React, { useMemo, useState } from 'react'

import { const_var, params } from '../../../../../redux/reducers/reducer'
import { extrudeSettings } from '../../../../../utils/Functions';
import { CSG } from '../../../../../assets/libs/csg-lib';

const VerticalLegs = ({ normalMap, envMap, meshDelModel_CSG }) => {  
    
    const [offset, setOffset] = useState(false);

    const railWidth = 0.1;
    const railHeight = 0.2;

    const height = useMemo(() => {
        let height = 0
        if(params.singleSlope){
            height = params.p_h - params.p_w * params.p_r_p / 12;
        } else {
            height = params.p_h;
        }
        
        return height
    }, [params.p_r_p, params.p_w, params.p_h, params.singleSlope])
    
    const legModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-railWidth / 2, -railHeight / 2);
        model.lineTo(-railWidth / 2, railHeight / 2);
        model.lineTo(railWidth / 2, railHeight / 2);
        model.lineTo(railWidth / 2, -railHeight / 2);
        model.closePath();
        
        return model;
    }, [])
    
    const modelPosYArr = useMemo(() => {
        let count, distance = 0;
        const initDistance = 4;
        
        const tempCount = Math.floor(height / initDistance);
        if (height === tempCount * initDistance) {
            count = tempCount;
            distance = initDistance;
        } else {
            count = tempCount + 1;
            distance = height / count;
        }
        
        const tempPosInfoArr = Array.from({ length: count + 2 }, (_, index) => distance * index)
        const posInfoArr = tempPosInfoArr.slice(1, -1);
        
        return posInfoArr
    }, [params.p_h, height])

    const frontBackModelPosYArr = useMemo(() => {
        let count, distance = 0;
        
        const initDistance = 4;
        const tempCount = Math.floor(( params.p_w * params.p_r_p / 12) / initDistance);
        const tempCount1 = Math.floor(height / initDistance);
        const count1 = tempCount1 + 1;
        const distance1 = height / count1;
        if (params.p_w * params.p_r_p / 12 === tempCount * initDistance) {
            count = tempCount;
            distance = initDistance;
        } else {
            count = tempCount + 1;
            distance = distance1
        }
        
        const tempPosInfoArr = Array.from({ length: count  }, (_, index) => distance * index)
        const posInfoArr = tempPosInfoArr.slice(1);
        
        return posInfoArr
    }, [params.p_h, height, params.p_w, params.p_r_p])

    const directionInfoArr = useMemo(() => {
        const wallWhiteSpace = 0.145
        let isShowFront = false;
        let isShowBack = false;
        let isShowLeft = false;
        let isShowRight = false;
        let isShowBackStorage = false;
        let isShowLeftStorage = false;
        let isShowRightStorage = false;

        if (params.p_f_w === 'Close') isShowFront = true;
        if (params.p_b_w === 'Close') isShowBack = true;
        if (params.p_l_w === 'Close') isShowLeft = true;
        if (params.p_r_w === 'Close') isShowRight = true;
        if (params.p_u_c) isShowBackStorage = true;
        if (params.cB_addStorage_check_left) isShowLeftStorage = true;
        if (params.cB_addStorage_check_right) isShowRightStorage = true;

        const dataArr = [
            {
                direction: 'front',
                isShow: isShowFront,
                size: params.p_w - 2 * railWidth,
                angle: Math.PI / 2,
                pos_x: -params.p_w / 2 + railWidth,
                pos_z: 0,
                end_pos_x: 0,
                end_pos_z: params.p_d / 2 + 0.08,
            },
            {
                direction: 'back',
                isShow: isShowBack,
                size: params.p_w - 2 * railWidth,
                angle: Math.PI / 2,
                pos_x: -params.p_w / 2 + railWidth,
                pos_z: 0,
                end_pos_x: 0,
                end_pos_z: -params.p_d / 2 - 0.08,
            },
            {
                direction: 'left',
                isShow: isShowLeft,
                size: params.p_d,
                angle: 0,
                pos_x: 0,
                pos_z: -params.p_d / 2,
                end_pos_x: -params.p_w / 2 + 0.11,
                end_pos_z: 0,
            },
            {
                direction: 'right',
                isShow: isShowRight,
                size: params.p_d,
                angle: 0,
                pos_x: 0,
                pos_z: -params.p_d / 2,
                end_pos_x: params.p_w / 2 - 0.11,
                end_pos_z: 0,
            },
            {
                direction: 'backStorageFront',
                isShow: isShowBackStorage,
                size: params.p_w - 2 * railWidth,
                angle: Math.PI / 2,
                pos_x: -params.p_w / 2 + railWidth,
                pos_z: 0,
                end_pos_x: 0,
                end_pos_z: -params.p_d / 2 + parseInt(params.p_u_t) + 0.08,
            },
            {
                direction: 'leftStorageFront',
                isShow: isShowLeftStorage,
                size: params.p_d + wallWhiteSpace * 2,
                angle: 0,
                pos_x: 0,
                pos_z: -params.p_d / 2 - wallWhiteSpace,
                end_pos_x: -params.p_w / 2 + parseInt(params.cB_addStorage_left) - 0.1,
                end_pos_z: 0,
            },
            {
                direction: 'rightStorageFront',
                isShow: isShowRightStorage,
                size: params.p_d + wallWhiteSpace * 2,
                angle: 0,
                pos_x: 0,
                pos_z: -params.p_d / 2 - wallWhiteSpace,
                end_pos_x: params.p_w / 2 - parseInt(params.cB_addStorage_right) + 0.1,
                end_pos_z: 0,
            }
        ]
        
        return dataArr;
    }, [params.p_w, params.p_d, params.p_f_w, params.p_b_w, params.p_l_w, params.p_r_w, params.p_u_t, params.p_u_c, params.cB_addStorage_left, params.cB_addStorage_check_left, params.cB_addStorage_right, params.cB_addStorage_check_right])

    const roofDirectionInfoArr = useMemo(() => {  
        let newDataArr = []
        const wallWhiteSpace = 0.145
        frontBackModelPosYArr.map(index => {
            let isShowFront = false;
            let isShowBack = false;
            let isShowRight = false;
            let isShowBackStorage = false;
            let isShowLeftStorage = false;
            let isShowRightStorage = false;
                
    
            if (params.p_f_w === 'Close') isShowFront = true;
            if (params.p_b_w === 'Close') isShowBack = true;
            if (params.p_r_w === 'Close') isShowRight = true;
            if (params.p_u_c) isShowBackStorage = true;
            if (params.cB_addStorage_check_left) isShowLeftStorage = true;
            if (params.cB_addStorage_check_right) isShowRightStorage = true;
            const dataArr = [
                {
                    direction: 'front',
                    isShow: isShowFront,
                    size: (params.p_w * (params.p_w * params.p_r_p / 12 - index) / (params.p_w * params.p_r_p / 12)) - 2 * railWidth,
                    angle: -Math.PI / 2,
                    pos_x: params.p_w / 2 - railWidth,
                    pos_z: 0,
                    end_pos_x: 0,
                    end_pos_z: params.p_d / 2 + 0.08,
                },
                {
                    direction: 'back',
                    isShow: isShowBack,
                    size: (params.p_w * (params.p_w * params.p_r_p / 12 - index) / (params.p_w * params.p_r_p / 12)) - 2 * railWidth,
                    angle: -Math.PI / 2,
                    pos_x: params.p_w / 2 - railWidth,
                    pos_z: 0,
                    end_pos_x: 0,
                    end_pos_z: -params.p_d / 2 - 0.08,
                },
                {
                    direction: 'right',
                    isShow: isShowRight,
                    size: params.p_d,
                    angle: 0,
                    pos_x: 0,
                    pos_z: -params.p_d / 2,
                    end_pos_x: params.p_w / 2 - 0.11,
                    end_pos_z: 0,
                },
                {
                    direction: 'backStorageFront',
                    isShow: isShowBackStorage,
                    size: (params.p_w * (params.p_w * params.p_r_p / 12 - index) / (params.p_w * params.p_r_p / 12)) - 2 * railWidth,
                    angle: -Math.PI / 2,
                    pos_x: params.p_w / 2 - railWidth,
                    pos_z: 0,
                    end_pos_x: 0,
                    end_pos_z: -params.p_d / 2 + parseInt(params.p_u_t) + 0.08,
                },
                {
                    direction: 'leftStorageFront',
                    isShow: isShowLeftStorage,
                    size: params.p_d + wallWhiteSpace * 2,
                    angle: 0,
                    pos_x: 0,
                    pos_z: -params.p_d / 2 - wallWhiteSpace,
                    end_pos_x: -params.p_w / 2 + parseInt(params.cB_addStorage_left) - 0.1,
                    end_pos_z: 0,
                },
                {
                    direction: 'rightStorageFront',
                    isShow: isShowRightStorage,
                    size: params.p_d + wallWhiteSpace * 2,
                    angle: 0,
                    pos_x: 0,
                    pos_z: -params.p_d / 2 - wallWhiteSpace,
                    end_pos_x: params.p_w / 2 - parseInt(params.cB_addStorage_right) + 0.1,
                    end_pos_z: 0,
                }
            ] 
            newDataArr.push(dataArr)
        })
       
        return newDataArr;
    }, [params.p_w, params.p_d, params.p_f_w, params.p_b_w, params.p_l_w, params.p_r_w, params.p_u_t, params.p_u_c, params.cB_addStorage_check_left, params.cB_addStorage_left, params.cB_addStorage_right, params.cB_addStorage_check_right, params.p_r_p, frontBackModelPosYArr])
    
    /************** cutting hole using CSG ***************/    
    const CSGRailGroupArr = useMemo(() => {
        let dataArr = [];

        modelPosYArr.map(model_pos_y => {
            directionInfoArr.map(element => {
                if (element.isShow) {
                    const railModel = new THREE.Mesh(new THREE.ExtrudeGeometry(legModel, extrudeSettings(element.size)));
                    let tempRailModel = railModel.clone();
                    tempRailModel.position.set(element.pos_x, model_pos_y, element.pos_z);
                    tempRailModel.rotateY(element.angle);
                    tempRailModel.updateMatrix();
                    tempRailModel.updateMatrixWorld();

                    const meshFrontDelModel = CSG.toMesh(
                        meshDelModel_CSG.front,
                        new THREE.Matrix4(),
                        new THREE.MeshStandardMaterial({ color: 'blue' })
                    )

                    const meshBackDelModel = CSG.toMesh(
                        meshDelModel_CSG.back,
                        new THREE.Matrix4(),
                        new THREE.MeshStandardMaterial({ color: 'blue' })
                    )

                    const meshLeftDelModel = CSG.toMesh(
                        meshDelModel_CSG.left,
                        new THREE.Matrix4(),
                        new THREE.MeshStandardMaterial({ color: 'blue' })
                    )

                    const meshRightDelModel = CSG.toMesh(
                        meshDelModel_CSG.right,
                        new THREE.Matrix4(),
                        new THREE.MeshStandardMaterial({ color: 'blue' })
                    )
                    
                    const meshFrontDelModelL_Temp = meshFrontDelModel.clone();
                    meshFrontDelModelL_Temp.position.set(params.p_w / 2 - parseInt(params.cB_addStorage_left) + 0.15 - 0.1, 0, params.p_d / 2 + 1.45);
                    meshFrontDelModelL_Temp.updateMatrix();
                    meshFrontDelModelL_Temp.updateMatrixWorld();

                    const meshBackDelModelL_Temp = meshBackDelModel.clone();
                    meshBackDelModelL_Temp.position.set(params.p_w / 2 - parseInt(params.cB_addStorage_left) + 0.15 - 0.1, 0, -params.p_d / 2 - 1.45);
                    meshBackDelModelL_Temp.updateMatrix();
                    meshBackDelModelL_Temp.updateMatrixWorld();

                    const meshFrontDelModelR_Temp = meshFrontDelModel.clone();
                    meshFrontDelModelR_Temp.position.set(-params.p_w / 2 + parseInt(params.cB_addStorage_right) - 0.15 + 0.1, 0, params.p_d / 2 + 1.45);
                    meshFrontDelModelR_Temp.updateMatrix();
                    meshFrontDelModelR_Temp.updateMatrixWorld();

                    const meshBackDelModelR_Temp = meshBackDelModel.clone();
                    meshBackDelModelR_Temp.position.set(-params.p_w / 2 + parseInt(params.cB_addStorage_right) - 0.15 + 0.1, 0, -params.p_d / 2 - 1.45);
                    meshBackDelModelR_Temp.updateMatrix();
                    meshBackDelModelR_Temp.updateMatrixWorld();


                    const meshLeftDelModel_Temp = meshLeftDelModel.clone();
                    meshLeftDelModel_Temp.position.set(-params.p_w / 2 - 1.3, 0, -params.p_d / 2 + parseInt(params.p_u_t) + 0.1);
                    meshLeftDelModel_Temp.rotateY(-Math.PI)
                    meshLeftDelModel_Temp.updateMatrix();
                    meshLeftDelModel_Temp.updateMatrixWorld();

                    const meshRightDelModel_Temp = meshRightDelModel.clone();
                    meshRightDelModel_Temp.position.set(params.p_w / 2 + 1.3, 0, -params.p_d / 2 + parseInt(params.p_u_t) + 0.1);
                    meshRightDelModel_Temp.rotateY(-Math.PI)
                    meshRightDelModel_Temp.updateMatrix();
                    meshRightDelModel_Temp.updateMatrixWorld();

                    const meshTempRailModel_CSG = CSG.fromMesh(tempRailModel);
                    const CSGMeshFrontDelModelR = CSG.fromMesh(meshFrontDelModelR_Temp);
                    const CSGMeshBackDelModelR = CSG.fromMesh(meshBackDelModelR_Temp);
                    const CSGMeshFrontDelModelL = CSG.fromMesh(meshFrontDelModelL_Temp);
                    const CSGMeshBackDelModelL = CSG.fromMesh(meshBackDelModelL_Temp);
                    const CSGMeshLeftDelModel = CSG.fromMesh(meshLeftDelModel_Temp);
                    const CSGMeshRightDelModel = CSG.fromMesh(meshRightDelModel_Temp);

                    let meshTempRailModel_CSG_Hole;
                    if(element.direction === 'leftStorageFront'){
                        const frontMeshTempRailModel_CSG_Hole = meshTempRailModel_CSG.subtract(meshDelModel_CSG[element.direction]);
                        const backMeshTempRailModel_CSG_Hole = frontMeshTempRailModel_CSG_Hole.subtract(CSGMeshFrontDelModelL);
                        meshTempRailModel_CSG_Hole = backMeshTempRailModel_CSG_Hole.subtract(CSGMeshBackDelModelL);
                        
                    } else if(element.direction === 'rightStorageFront'){
                        const frontMeshTempRailModel_CSG_Hole = meshTempRailModel_CSG.subtract(meshDelModel_CSG[element.direction]);
                        const backMeshTempRailModel_CSG_Hole = frontMeshTempRailModel_CSG_Hole.subtract(CSGMeshFrontDelModelR);
                        meshTempRailModel_CSG_Hole = backMeshTempRailModel_CSG_Hole.subtract(CSGMeshBackDelModelR);
                        
                    } else if(element.direction === 'backStorageFront'){
                        const leftMeshTempRailModel_CSG_Hole = meshTempRailModel_CSG.subtract(meshDelModel_CSG[element.direction]);
                        const rightMeshTempRailModel_CSG_Hole = leftMeshTempRailModel_CSG_Hole.subtract(CSGMeshLeftDelModel);
                        meshTempRailModel_CSG_Hole = rightMeshTempRailModel_CSG_Hole.subtract(CSGMeshRightDelModel);
                        
                    } else {
                        meshTempRailModel_CSG_Hole = meshTempRailModel_CSG.subtract(meshDelModel_CSG[element.direction]);

                    }
                    const CSGRailModel = CSG.toMesh(
                        meshTempRailModel_CSG_Hole,
                        new THREE.Matrix4(),
                    )
                    dataArr.push({ direction: element.direction, CSGRailModel });
                }    
            })
        })
        
        return dataArr;
    }, [modelPosYArr, directionInfoArr, meshDelModel_CSG, legModel, params.p_w, params.p_d, parseInt(params.p_u_t), parseInt(params.cB_addStorage_left), parseInt(params.cB_addStorage_right)])

    const CSGFrontBackRailGroupArr = useMemo(() => {
      
        let dataArr = [];

        if (offset) {
            frontBackModelPosYArr.map((model_pos_y, index) => {
                roofDirectionInfoArr[index].map(element => {
                    if (element.isShow) {

                        const modelPosY = model_pos_y + (params.p_h - params.p_w * params.p_r_p / 12)
                        const leftStorageHeight = params.p_h - params.p_w * params.p_r_p / 12 + parseInt(params.cB_addStorage_left) * params.p_r_p / 12 - 0.2;
                        const rightStorageHeight = params.p_h - params.p_w * params.p_r_p / 12 + (params.p_w - parseInt(params.cB_addStorage_right)) * params.p_r_p / 12 - 0.2;

                        const railModel = new THREE.Mesh(new THREE.ExtrudeGeometry(legModel, extrudeSettings(element.size)));
                        let tempRailModel = railModel.clone();
                        tempRailModel.position.set(element.pos_x, modelPosY, element.pos_z);
                        tempRailModel.rotateY(element.angle);
                        tempRailModel.updateMatrix();
                        tempRailModel.updateMatrixWorld();

                        const meshFrontDelModel = CSG.toMesh(
                            meshDelModel_CSG.front,
                            new THREE.Matrix4(),
                            new THREE.MeshStandardMaterial({ color: 'blue' })
                        )
    
                        const meshBackDelModel = CSG.toMesh(
                            meshDelModel_CSG.back,
                            new THREE.Matrix4(),
                            new THREE.MeshStandardMaterial({ color: 'blue' })
                        )
    
                        const meshLeftDelModel = CSG.toMesh(
                            meshDelModel_CSG.left,
                            new THREE.Matrix4(),
                            new THREE.MeshStandardMaterial({ color: 'blue' })
                        )
    
                        const meshRightDelModel = CSG.toMesh(
                            meshDelModel_CSG.right,
                            new THREE.Matrix4(),
                            new THREE.MeshStandardMaterial({ color: 'blue' })
                        )
                        
                        const meshFrontDelModelL_Temp = meshFrontDelModel.clone();
                        meshFrontDelModelL_Temp.position.set(params.p_w / 2 - parseInt(params.cB_addStorage_left) + 0.15 - 0.1, 0, params.p_d / 2 + 1.45);
                        meshFrontDelModelL_Temp.updateMatrix();
                        meshFrontDelModelL_Temp.updateMatrixWorld();
    
                        const meshBackDelModelL_Temp = meshBackDelModel.clone();
                        meshBackDelModelL_Temp.position.set(params.p_w / 2 - parseInt(params.cB_addStorage_left) + 0.15 - 0.1, 0, -params.p_d / 2 - 1.45);
                        meshBackDelModelL_Temp.updateMatrix();
                        meshBackDelModelL_Temp.updateMatrixWorld();
    
                        const meshFrontDelModelR_Temp = meshFrontDelModel.clone();
                        meshFrontDelModelR_Temp.position.set(-params.p_w / 2 + parseInt(params.cB_addStorage_right) - 0.15 + 0.1, 0, params.p_d / 2 + 1.45);
                        meshFrontDelModelR_Temp.updateMatrix();
                        meshFrontDelModelR_Temp.updateMatrixWorld();
    
                        const meshBackDelModelR_Temp = meshBackDelModel.clone();
                        meshBackDelModelR_Temp.position.set(-params.p_w / 2 + parseInt(params.cB_addStorage_right) - 0.15 + 0.1, 0, -params.p_d / 2 - 1.45);
                        meshBackDelModelR_Temp.updateMatrix();
                        meshBackDelModelR_Temp.updateMatrixWorld();
    
    
                        const meshLeftDelModel_Temp = meshLeftDelModel.clone();
                        meshLeftDelModel_Temp.position.set(-params.p_w / 2 - 1.3, 0, -params.p_d / 2 + parseInt(params.p_u_t) + 0.1);
                        meshLeftDelModel_Temp.rotateY(-Math.PI)
                        meshLeftDelModel_Temp.updateMatrix();
                        meshLeftDelModel_Temp.updateMatrixWorld();
    
                        const meshRightDelModel_Temp = meshRightDelModel.clone();
                        meshRightDelModel_Temp.position.set(params.p_w / 2 + 1.3, 0, -params.p_d / 2 + parseInt(params.p_u_t) + 0.1);
                        meshRightDelModel_Temp.rotateY(-Math.PI)
                        meshRightDelModel_Temp.updateMatrix();
                        meshRightDelModel_Temp.updateMatrixWorld();
    
                        const meshTempRailModel_CSG = CSG.fromMesh(tempRailModel);
                        const CSGMeshFrontDelModelR = CSG.fromMesh(meshFrontDelModelR_Temp);
                        const CSGMeshBackDelModelR = CSG.fromMesh(meshBackDelModelR_Temp);
                        const CSGMeshFrontDelModelL = CSG.fromMesh(meshFrontDelModelL_Temp);
                        const CSGMeshBackDelModelL = CSG.fromMesh(meshBackDelModelL_Temp);
                        const CSGMeshLeftDelModel = CSG.fromMesh(meshLeftDelModel_Temp);
                        const CSGMeshRightDelModel = CSG.fromMesh(meshRightDelModel_Temp);
    
                        let meshTempRailModel_CSG_Hole;
                        if(element.direction === 'leftStorageFront'){
                            const frontMeshTempRailModel_CSG_Hole = meshTempRailModel_CSG.subtract(meshDelModel_CSG[element.direction]);
                            const backMeshTempRailModel_CSG_Hole = frontMeshTempRailModel_CSG_Hole.subtract(CSGMeshFrontDelModelL);
                            meshTempRailModel_CSG_Hole = backMeshTempRailModel_CSG_Hole.subtract(CSGMeshBackDelModelL);
                            
                        } else if(element.direction === 'rightStorageFront'){
                            const frontMeshTempRailModel_CSG_Hole = meshTempRailModel_CSG.subtract(meshDelModel_CSG[element.direction]);
                            const backMeshTempRailModel_CSG_Hole = frontMeshTempRailModel_CSG_Hole.subtract(CSGMeshFrontDelModelR);
                            meshTempRailModel_CSG_Hole = backMeshTempRailModel_CSG_Hole.subtract(CSGMeshBackDelModelR);
                            
                        } else if(element.direction === 'backStorageFront'){
                            const leftMeshTempRailModel_CSG_Hole = meshTempRailModel_CSG.subtract(meshDelModel_CSG[element.direction]);
                            const rightMeshTempRailModel_CSG_Hole = leftMeshTempRailModel_CSG_Hole.subtract(CSGMeshLeftDelModel);
                            meshTempRailModel_CSG_Hole = rightMeshTempRailModel_CSG_Hole.subtract(CSGMeshRightDelModel);
                            
                        } else {
                            meshTempRailModel_CSG_Hole = meshTempRailModel_CSG.subtract(meshDelModel_CSG[element.direction]);
    
                        }
                        
                        const CSGRailModel = CSG.toMesh(
                            meshTempRailModel_CSG_Hole,
                            new THREE.Matrix4(),
                        )
                        if (element.direction === 'leftStorageFront' || element.direction === 'rightStorageFront') {
                            if ((element.direction === 'leftStorageFront' && modelPosY <= leftStorageHeight) || (element.direction === 'rightStorageFront' && modelPosY <= rightStorageHeight)) {
                                dataArr.push({ direction: element.direction, CSGRailModel });
                            }
                        } else {
                            dataArr.push({ direction: element.direction, CSGRailModel });
                        }
                    }
                })
            })
        }
        
        return dataArr;
    }, [frontBackModelPosYArr, roofDirectionInfoArr, meshDelModel_CSG, legModel, params.p_w, params.p_h, params.p_r_p])
    
    /****************************************** **********/
    
    useMemo(() => {
        if((params.p_w * params.p_r_p / 12) > frontBackModelPosYArr[0]){
            setOffset(true)
        } else{
            setOffset(false)
        }
    }, [params.p_h, params.p_w, params.p_r_p]);
    
    
    return params.p_v_w && (
        <group name='vertical_legs'>
            {CSGRailGroupArr.map((item, index) =>
                <mesh
                    name={`vertical_${item.direction}_leg`}
                    geometry={item.CSGRailModel.geometry}
                    position={[
                        directionInfoArr.find(child => child.direction === item.direction).end_pos_x,
                        -0.1,
                        directionInfoArr.find(child => child.direction === item.direction).end_pos_z
                    ]}>
                    <meshPhongMaterial color={"#F0F0F0"} map={normalMap} envMap={envMap} side={THREE.DoubleSide} reflectivity={0.4} />
                </mesh>
                
            )}
            {params.singleSlope &&
                CSGFrontBackRailGroupArr.map((item, index) =>
                    <mesh
                        name={`vertical_${item.direction}_leg`}
                        geometry={item.CSGRailModel.geometry}
                        position={[
                            directionInfoArr.find(child => child.direction === item.direction).end_pos_x,
                            -0.1,
                            directionInfoArr.find(child => child.direction === item.direction).end_pos_z
                        ]}>
                        <meshPhongMaterial color={"#F0F0F0"} map={normalMap} envMap={envMap} side={THREE.DoubleSide} reflectivity={0.4} />
                    </mesh>
                    
                )
            }
        </group>
    )
}

export default VerticalLegs